import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyB96QUczIrnC2Mh0pU0MxIhzXXkVszF4kg",
    authDomain: "slam-project-136f8.firebaseapp.com",
    projectId: "slam-project-136f8",
    storageBucket: "slam-project-136f8.appspot.com",
    messagingSenderId: "424948891616",
    appId: "1:424948891616:web:370ac176bb259b031af585",
    measurementId: "G-6R2ZSTB3G9"
};

const app = initializeApp(firebaseConfig);

const storage = getStorage(app);
const auth = getAuth(app)
const db = getFirestore(app); 

export { db, auth, storage };